class TravelSimBuy {
	constructor(options) {
		this.state = {
			country: null,
			region: null,
			product: null,
		};
		this.wrapper = document.getElementById('buy_travel_sim');
		if (!this.wrapper) {
			throw new Error('Missing main wrapper element');
		}
		this.destination_i = this.wrapper.querySelector('#destination');
		this.h_country_details = this.wrapper.querySelector('#country_details');

		let _that = Object.assign(this, options);
		console.log('TravelSimBuy(%o)', this);

		this.updateState();
	}

	async updateState() {
		if (this.state.country) {
			await this.setRegionBinds();

			if (this.state.region) {
				await this.changeRegion(this.state.region);
				await this.setProductBinds();

				if (this.state.product) {
					await this.changeProduct(this.state.product);
				}
			}
		}

		this.updateUrl();
	}

	updateUrl() {
		const url = new URL(window.location.href);
		url.searchParams.delete('destination');
		url.searchParams.delete('region');
		url.searchParams.delete('hash');
		let new_url = '/buy/travel_sim';
		if (this.state.country) {
			new_url += '/' + encodeURIComponent(this.state.country.name);
			if (this.state.region) {
				new_url += '/' + encodeURIComponent(this.state.region);
			}
		}
		url.pathname = s.url(new_url);

		window.history.replaceState(this.state, '', url.toString());
	}

	setCountryBinds() {
		this.destination_i.addEventListener('change', async e => {
			e.preventDefault();
			const option = this.destination_i.options[this.destination_i.selectedIndex];
			await this.changeCountry({
				code: option.dataset.countryCode,
				name: option.dataset.countryName,
			});
			await this.setRegionBinds();
			await this.changeRegion(this.state.region);
			await this.setProductBinds();
			await this.changeProduct(this.state.product);
		});
	}
	async setRegionBinds() {
		console.log('TravelSimBuy::setRegionBinds()');
		this.form_buy_travel_sim = this.wrapper.querySelector('#form_buy_travel_sim');
		if (this.form_buy_travel_sim) {
			this.i_products_quantity = this.form_buy_travel_sim.querySelector('[name="products[0][quantity]"]');
			this.i_products_product_identifier = this.form_buy_travel_sim.querySelector('[name="products[0][product_data][product_identifier]"]');
		}

		const region_selectors = this.wrapper.querySelectorAll('#regions .region');
		region_selectors?.forEach(region_i => {
			region_i.addEventListener('click', async e => {
				e.preventDefault();

				region_selectors.forEach(_region_i => {
					if (_region_i !== region_i) {
						_region_i.classList.remove( 'active');
					}

					region_i.classList.add('active');
				});

				this.state.region = region_i.dataset.region;
				this.state.product = null;
				await this.changeRegion(this.state.region);
				await this.changeProduct(this.state.product);
			})
		});
	}

	async setProductBinds() {
		console.log('TravelSimBuy::setProductBinds()');
		const product_buttons = this.wrapper.querySelectorAll('#region_products .product');
		product_buttons?.forEach(product => {
			product.addEventListener('click', e => {
				product_buttons.forEach(_product => {
					_product.classList.remove('active');
				})

				product.classList.add('active');
				this.state.product = {
					amount: product.dataset.sale,
					identifier: product.dataset.product_identifier,
					url_hash: product.dataset.url_hash,
					external_id: product.dataset.product_external_id,
				};

				this.changeProduct(this.state.product);
			})
		});


	}

	async changeCountry(country) {
		console.log('TravelSimBuy::changeCountry(%o)', country);
		const form_data = new FormData();
		form_data.append('action', 'get_country_operators');
		form_data.append('country_code', country.code);
		const products = this.wrapper.querySelectorAll('#region_products .product');
		products?.forEach(product => {
			product.classList.add('blur');
		});
		const region_selectors = this.wrapper.querySelectorAll('#regions .region');
		region_selectors?.forEach(region_i => {
			region_i.classList.add('blur');
		});
		const fetch = s.common.fetcher(
			s.url('/process/travel_sim'),
			{
				method: 'post',
				body: form_data,
			}
		);

		const response = await fetch.ready;
		this.h_country_details.innerHTML = response.html;
		this.state = response.state;

		this.updateUrl();
	}

	hasMultipleOperators(region) {
		let operatorId;
		let hasOperatorId = false;

		document.querySelectorAll(`div[data-region="${region}"]`).forEach((element, index) => {
			if (index === 0) {
				operatorId = element.dataset.region_operator_id;
			} else if (operatorId !== element.dataset.region_operator_id) {
				return hasOperatorId = true;
			}
		});

		return hasOperatorId;
	}
	
	clearDetails() {
		document.querySelectorAll('[data-region_external_id]:not(.d-none)').forEach((e) => {
			e.classList.add('d-none');
		});
	}

	async changeRegion(region) {
		console.log('TravelSimBuy::changeRegion(%o)', region);

		const country_products = this.wrapper.querySelectorAll('#region_products .product');
		const region_products = [];
		country_products?.forEach(product => {
			if (product.dataset.region === region) {
				region_products.push(product);
				product.classList.remove('d-none', 'blur');
			} else {
				product.classList.remove('blur');
				product.classList.add('d-none');
			}
		});
		if (region_products.length === 1) {
			const product = region_products[0];
			this.state.product = {
				amount: product.dataset.sale,
				identifier: product.dataset.product_identifier,
				url_hash: product.dataset.url_hash,
			}
			product.classList.add('active');
		}

		const regions_details = this.wrapper.querySelectorAll('#regions_details .region');
		regions_details.forEach(region_details => {
			if (region_details.dataset.region === region) {
				region_details.classList.remove('d-none');
			} else {
				region_details.classList.add('d-none');
			}
		});

		const banner = document.querySelector('.banner-content');
		if (this.hasMultipleOperators(region)) {
			banner.classList.add('d-none');
		} else {
			banner.classList.remove('d-none');
			this.clearDetails();
			document.querySelector(`div[data-region="${region}"]`).classList.remove('d-none');
		}
		this.updateUrl();
	}

	async changeProduct(product){
		console.log('TravelSimBuy::changeProduct(%o)', product);
		const bannerContent = document.querySelector('.banner-content');

		if (product) {
			this.i_products_quantity.value = product.amount;
			this.i_products_product_identifier.value = product.identifier;
			this.form_buy_travel_sim.querySelector('button[type=submit]').disabled = false;

			const regionElement = document.querySelector(`[data-region_external_id="${product?.external_id}"]`);
			if (this.hasMultipleOperators(regionElement.dataset.region)) {
				this.clearDetails();
				if (product?.external_id && bannerContent) {
					bannerContent.classList.remove('d-none');
	
					if (regionElement) {
						regionElement.classList.remove('d-none');
					}
				}
			}

		} else {
			const region_products = this.wrapper.querySelectorAll('#region_products .product');
			region_products?.forEach(region_product => {
				region_product.classList.remove('active');
			});

			this.i_products_quantity.value = '';
			this.i_products_product_identifier.value = '';
			this.form_buy_travel_sim.querySelector('button[type=submit]').disabled = true;

			if (this.hasMultipleOperators(this.state.region)) {
				this.clearDetails();

				if (bannerContent) {
					bannerContent.classList.add('d-none');
				}
			}
		}

		this.updateUrl();
	}
}
